export default function Section({ children, className = "mb-3", style = {} }) {
  return (
    <section className={`p-3 mb-5 ${className}`} style={style}>
      {children}
    </section>
  );
}
